import {DateTimeString, GuidString} from "../../models/BrandedTypes";
import { Address } from "../Context/memberContext/types/Address";
import { MemberContextRoot } from "../Context/memberContext/types/MemberContextRoot";


export * from "../Context/memberContext/types/Contact";
export * from "../Context/memberContext/types/CurrentProduct";
export * from "../Context/memberContext/types/GasEngineer";
export * from "../Context/memberContext/types/Membership";
export * from "../Context/memberContext/types/SocialMediaLinks";
export * from "../Context/memberContext/types/PaymentType"

export type MemberDetailsInfo = MemberContextRoot & {
    companyType: CompanyType;
    companyNumber: string;
}

export type PartnerVoucher = {

    value: number,
    expiry: string,
    rebateBranchName: string,
    creditNoteNumber: string,   
    dateClaimed: string,
    dateIssued: string,
    barcodeNumber: string,
    name: string,
    bookerCustomerNumber: string
    state: 'Claimed' | 'Processing' | 'Issued' | 'Broken' | 'Expired'
}

export type MissingCompanyDetails = {
    companyTypeId: number
    companyRegistrationOrCharityNumber: string;
    vatRegistered: boolean;
}

export type Title = {
    text: string;
    id: number;
}

export type CompanyDetails = {
    mailingAddress: Address;
    primaryContactId: number;
    tradingName: string;
    website: string;
    twitter: string;
    instagram: string;
    facebook: string;
    mainPhone: string;
    balance: number;
    membershipNumber: string;
    dateStartedTrading: Date;
    yearsTrading: number;
    numberOfTradingUnits: number;
    companyType: CompanyType;
    companyRegistrationorCharityNumber: string;
    name: string;
    id: string;
}

export type CompanyType = {
    id: number;
    text: string;
}

export enum CompanyTypeOption {
    SoleTrader = "Sole Trader",
    LimitedCompany = "Limited Company",
    PLC = "PLC",
    Charity = "Charity",
    LLP = "LLP",
    BusinessNotRegistered = "Business not registered",
    Partnerships = "Partnerships"
}

export enum MembershipTier {
    Standard = 1,
    Premium = 2,
    PremiumPlus = 3,
    Pro = 4
}

export type MembershipBenefits = {
    StandardBenefits: Benefit[];
}

export type Benefit = {
    name: string,
    namePlural: string,
    quantity: number,
    currentQty?: number,
    discount: string
}

export type ReferenceTypes = {
  benefitClassification: BenefitClassification[]
  benefitItem: BenefitItem[]
  localAuthority: LocalAuthority[]
  companyType: CompanyType[]
  contactTitles: ContactTitle[]
  downgradeReasons: DowngradeReason[]
  equipmentList: EquipmentList[]
  foodType: FoodType[]
  typeOfBusiness: TypeOfBusiness[]
  unitType: UnitType[]
  whatDoYouWantMostFromMembership: WhatDoYouWantMostFromMembership[]
  whereDidYouHearAboutUs: WhereDidYouHearAboutUs[]
  productTier: ProductTier[]
  paymentTypes: PaymentType[]
  membershipTypes: string[]
  intentionToRenewOptions: IntentionToRenewOption[]
  validationConstants: ValidationConstants
}

export type BenefitClassification = {
  id: string
  text: string
}

export type BenefitItem = {
  id: string
  text: string
}

export type LocalAuthority = {
  id: string
  text: string
}

export type ContactTitle = {
  id: number
  text: string
}

export type DowngradeReason = {
  id: string
  text: string
}

export type EquipmentList = {
  id: string
  text: string
}

export type FoodType = {
  id: string
  text: string
}

export type TypeOfBusiness = {
  id: number
  text: string
}

export type UnitType = {
  id: string
  text: string
}

export type WhatDoYouWantMostFromMembership = {
  id: number
  text: string
}

export type WhereDidYouHearAboutUs = {
  id: number
  text: string
}

export type ProductTier = {
  id: number
  text: string
}

export type PaymentType = {
  id: string
  name: string
  bankAccountRequired: boolean
  isCardPayment: boolean
  isContinuousPayment: any
}

export type IntentionToRenewOption = {
  id: number
  text: string
}

export type ValidationConstants = {
  nameMaxLength: number
  addressLineMaxLength: number
  townMaxLength: number
  countyMaxLength: number
  emailMaxLength: number
  socialMediaMaxLength: number
  websiteMaxLength: number
}


